import { useState } from 'react';
import { PremiumHeader } from '@/components/premium/PremiumHeader';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      
      toast.success('OTP sent to your email!');
      
      // Navigate to OTP verification page
      navigate('/verify-otp', { state: { email } });
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen noise-texture">
      <PremiumHeader />

      <div className="container mx-auto px-4 sm:px-8 py-20">
        <div className="max-w-md mx-auto bg-white border border-border rounded-none p-8">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-10 h-10 text-primary" />
            </div>
            <h1 className="text-3xl font-black uppercase mb-2">FORGOT PASSWORD?</h1>
            <p className="text-sm text-muted-foreground">
              Enter your email address and we'll send you a verification code
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="uppercase tracking-wider text-xs font-bold">Email Address</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your.email@example.com"
                disabled={loading}
                className="bg-transparent border-b-2 border-border focus:border-primary rounded-none px-0 py-4"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-accent text-accent-foreground hover:bg-primary hover:text-primary-foreground rounded-none uppercase tracking-wider font-bold py-6"
            >
              {loading ? 'SENDING...' : 'SEND OTP'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link 
              to="/login" 
              className="inline-flex items-center gap-2 text-sm text-primary hover:text-accent transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Login
            </Link>
          </div>

          <div className="mt-8 p-4 bg-accent/10 border border-accent rounded-none">
            <p className="text-xs text-center text-muted-foreground">
              💡 You'll receive a 6-digit code via email. The code is valid for 10 minutes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
